<template>
  <div>
    <Breadcrumbs main="Inventario" title="Editar Producto" v-if="objectId"/>
    <Breadcrumbs main="Inventario" title="Agregar Producto" v-else/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5 v-if="objectId">Editar Producto</h5>
              <h5 v-else>Agregar Producto</h5>
            </div>
            <div class="card-body">
              <b-form class="needs-validation">
                <div class="form-row">
                  <label>Imagen del producto (requerido)</label>
                  <div class="col-md-12 mb-3">
                    <vue-dropify
                            message="Arrastra una imagen o haz click aquí."
                            uploadIcon="fa fa-upload"
                            removeIcon='fa fa-trash'
                            unit="mb"
                            @upload="uploadImage"
                            ref="uploadImage"
                    ></vue-dropify>
                    <b-form-invalid-feedback :state="form.image.is_valid">{{form.image.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="client_id">Cliente (requerido)</label>
                    <multiselect placeholder="Selecciona un cliente" id="client_id"
                                 label="business_name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.client.value" :options="form.client.options"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                                 @input="setCategory(form.category, form.client.value)">
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                      <template slot="noOptions">No hay clientes disponibles.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.client.is_valid">{{form.client.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="type_id">Tipo de Producto (requerido)</label>
                    <multiselect placeholder="Un tipo" id="type_id"
                                 label="name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar" selected
                                 v-model="form.type.value" :options="form.type.options"
                                 :close-on-select="true" :show-labels="true" :allow-empty="false"
                                 @input="setTypeProduct(form.type.value.id)">
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                      <template slot="noOptions">No hay clientes disponibles.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.client.is_valid">{{form.client.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3" v-if="form.type.value.id === 'P'">
                    <label>Nombre del Pack (requerido)</label>
                    <b-form-input
                        type="text"
                        v-model="form.pack_name.value">

                    </b-form-input>
                    <b-form-invalid-feedback :state="form.pack_name.is_valid">{{form.pack_name.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="category_id">Categoría (requerido)</label>
                    <multiselect placeholder="Selecciona una categoría" id="category_id"
                                 label="name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.category.value" :options="form.category.options"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                    >
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                      <template slot="noOptions">Debes seleccionar un cliente que tenga categorías activas.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.category.is_valid">{{form.category.message_error}}</b-form-invalid-feedback>
                  </div>
                </div>
              </b-form>
              <div class="row" v-if="form.type.value.id === 'U'">
                <div class="col-md-12 mb-3">
                  <label for="stock_id">Stock inicial (requerido)</label>
                  <b-form-input
                      type="number" id="stock_id" placeholder="0" min="0"
                      v-model="form.initial_stock.value">
                  </b-form-input>
                  <b-form-invalid-feedback :state="form.initial_stock.is_valid">{{form.initial_stock.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="type_id">Tipo de producto (requerido)</label>
                  <multiselect placeholder="Selecciona un privilegio" id="type_id"
                               label="name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="form.specific_product.value" :options="form.specific_product.options"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="form.specific_product.is_valid">{{form.specific_product.message_error}}</b-form-invalid-feedback>
                </div>
              </div>
              <div class="row" v-if="form.specific_product.value.id === 'wi'">
                <div class="col-md-12 mb-3">
                  <label>CC (requerido)</label>
                  <b-form-input
                          type="number" placeholder="0" min="0"
                          v-model="form.productwine.cc.value">
                  </b-form-input>
                  <b-form-invalid-feedback :state="form.productwine.cc.is_valid">{{form.productwine.cc.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-md-12 mb-3">
                  <label>Año (opcional)</label>
                  <b-form-input
                          type="number" placeholder="0" min="0"
                          v-model="form.productwine.year.value">
                  </b-form-input>
                  <b-form-invalid-feedback :state="form.productwine.year.is_valid">{{form.productwine.year.message_error}}</b-form-invalid-feedback>
                </div>
              </div>
              <div class="col-12 mb-5" v-if="form.type.value.id === 'P'">
                <a class="pull-right" href="javascript:void(0);" title="Apregar producto" v-on:click="addProduct(form.pack, productId)">
                  <span class="badge badge-success"><i class="fa fa-plus"></i> Agregar producto</span>
                </a>
              </div>
              <div class="row" v-for="product in form.pack" v-show="form.type.value.id === 'P'" v-on:mouseenter="setLastRowSelected(product)">
                <div class="col-4 mb-3">
                  <label>Categoría (requerido)</label>
                  <multiselect placeholder="Selecciona una categoría"
                               label="name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="product.category.value" :options="product.category.options"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                               @input="setProductByCategory(product, product.category.value.id)">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                    <template slot="noOptions">No hay elementos en esta lista.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="product.category.is_valid">{{product.category.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-4 mb-3">
                  <label>Producto (requerido)</label>
                  <multiselect placeholder="Selecciona un producto"
                               label="small_name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="product.product.value" :options="product.product.options"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                               @input="setProductFilter(form.pack, product)">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                    <template slot="noOptions">No hay elementos en esta lista.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="product.product.is_valid">{{product.product.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-3 mb-3">
                  <label>Unidades a utilizar (requerido)</label>
                  <b-form-input
                      type="number" min="1"
                      v-model="product.stock.value">
                  </b-form-input>
                  <a href="javascript:void(0);" class="mr-2" title="Actualizar stock" v-on:click="setProductByCategory(product, product.category.value.id, product.product.value.id)">
                    <span class="badge badge-primary mt-2" v-if="product.product.value !== ''"><i class="fa fa-refresh"></i></span>
                  </a>
                  <span class="badge badge-success mt-2" v-if="product.product.value !== ''">{{product.product.value.invoice_stock}} disponible(s)</span>
                  <b-form-invalid-feedback :state="product.stock.is_valid">{{product.stock.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-1-mb-3">
                  <button type="button" class="btn btn-danger m-t-30" v-on:click="deleteProduct(form.pack, product.id.value)"><i class="fa fa-times"></i></button>
                </div>
              </div>
              <div v-if="form.type.value.id === 'P'" class="col-12 mb-5">
                <a class="pull-right" href="javascript:void(0);" title="Apregar producto" v-on:click="addProduct(form.pack, productId)">
                  <span class="badge badge-success"><i class="fa fa-plus"></i> Agregar producto</span>
                </a>
              </div>
              <b-button type="button" variant="primary" @click="onSubmit" v-if="objectId">Editar producto</b-button>
              <b-button type="button" variant="success" @click="onSubmit" v-else>Agregar producto</b-button>
              <b-button type="button" variant="warning" class="ml-1" :to="{'name': 'InventoryProductList'}">Volver</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import axios from 'axios';
  import VueDropify from 'vue-dropify';
  import Multiselect from 'vue-multiselect';
  import utils from '../../../utils';

  export default {
    components: {
      'vue-dropify': VueDropify,
      Multiselect
    },
    data(){
      return {
        objectId: null,
        productId: 1,
        // FIELD PARA OBTENER LAS CATEGORÍAS
        categoryField: utils.defaultFields({_type: 'select'}),
        form: {
          image: utils.defaultFields(),
          initial_stock: utils.defaultFields({
            value: 0
          }),
          status: utils.defaultFields({
            value: true
          }),
          specific_product: utils.defaultFields(
              {
                _type: 'select',
                value: utils.specificProduct.find(options => options['id'] === '--'),
                options: utils.specificProduct
              }
          ),
          client: utils.defaultFields({
            _type: 'select',
          }),
          type: utils.defaultFields({
            _type: 'select',
            value: utils.typeProduct.find(options => options['id'] === 'U'),
            options: utils.typeProduct
          }),
          pack_name: utils.defaultFields({
            required: false
          }),
          category: utils.defaultFields({
            _type: 'select',
          }),
          productwine: {
            year: utils.defaultFields({required: false}),
            cc: utils.defaultFields({required: false})
          },
          pack: []
        },
      }
    },
    async mounted () {
      this.objectId = this.$route.params.objectId;
      if(this.objectId){
        await this.getClient(this.form.client);
        await this.loadData(this.objectId);
        await this.getTreeCategory(this.form.category, this.form.client.value['id'], '_all_');
      }else{
        await this.getClient(this.form.client);
      }
    },
    methods: {
      onSubmit(evt){
        // console.log(evt)
        evt.preventDefault();
        // AQUÍ GUARDARÉ EL JSON FINAL PARA QUE SEA ENVIADO AL POST
        let data = {};
        const is_valid = utils.generateJsonStructure(this.form, data);
        if(is_valid){
          let _formData = new FormData();
          if(!utils.isDict(data.image)){
            delete data.image;
          }
          Object.keys(data).forEach(key => _formData.append(key, data[key]));
          _formData.delete('productwine');
          _formData.delete('pack');
          // SI NO AGREGO UN ORIDUCTI ESPECÍFICO GENERO EL JSONSTRING
          if(data['specific_product'] !== '--'){
            _formData.append('productwine', JSON.stringify(data['productwine']));
          }
          if(data['type'] === 'P'){
            _formData.append('pack', JSON.stringify(data['pack']));
          }
          let _type = 'agregar un producto';
          if(this.objectId){
            _type = 'modificar un producto'
          }
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de ${_type}.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              if(!this.objectId){
                const path = '/api/inventory/v1.0/product/';
                const headers = {'Content-Type': 'multipart/form-data'};
                await axios.post(path, _formData, {headers: headers}).then(async () => {
                  // console.log(response);
                  await this.$swal({
                    title: 'Agregado',
                    type: 'success',
                    html: `Se ha agregado el producto de manera correcta.`,
                  }).then(() => {
                    this.$router.push({'name': 'InventoryProductList'});
                  });
                }).catch(async (error) => {
                  // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                  console.log(error.response);
                  if(error.response.status === 400){
                    utils.generateBackendError(this.form, error.response.data);
                    await this.$swal({
                      title: 'Error',
                      type: 'error',
                      html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                  }
                });
              } else {
                const path = `/api/inventory/v1.0/product/${this.objectId}/`;
                const headers = {'Content-Type': 'multipart/form-data'};
                await axios.patch(path, _formData, {headers: headers}).then(async () => {
                  // console.log(response);
                  await this.$swal({
                    title: 'Modificado',
                    type: 'success',
                    html: `Se ha modificado el producto de manera correcta.`,
                  }).then(() => {
                    this.$router.push({'name': 'InventoryProductList'});
                  });
                }).catch(async (error) => {
                  // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                  console.log(error.response);
                  if(error.response.status === 400){
                    utils.generateBackendError(this.form, error.response.data);
                    await this.$swal({
                      title: 'Error',
                      type: 'error',
                      html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                  }
                });
              }
            }
          });
        }else{
          this.$swal({
            title: 'Error',
            type: 'error',
            html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
          });
        }
      },
      uploadImage(event){
        this.$refs.uploadImage.images = [];
        this.form.image.value = event[0];
      },
      async getTreeCategory(inputCategory, clientId, type, categoryId){
        let path;
        if(categoryId){
          path = `/api/inventory/v1.0/tree_category/${categoryId}/`;
        }else{
          path = `/api/inventory/v1.0/tree_category/`;
        }
        const config = {
          params: {
            client_id: clientId,
            type: type,
            status: true
          }
        };
        await axios.get(path, config).then((response) => {
          response.data.forEach((item) => {
            if(item['id'] !== ''){
              inputCategory.options.push(
                  item
              );
            }
          })

          if(inputCategory.value){
            inputCategory.value = inputCategory.options.find(option => inputCategory.value === option.id);
          }
        }).catch((error) => {
          console.log(error.response);
        });
      },
      async setCategory(fieldCategory, clientId){
        if(clientId !== null){
          this.getTreeCategory(fieldCategory, clientId.id, '_all_');
          if (this.form.type.value.id === 'P') {
            await this.getWithOutTreeCategory(this.categoryField, clientId.id)
          }

        }else{
          fieldCategory.value = '';
          fieldCategory.options = [];
        }
      },
      async setTypeProduct(typeProduct){
        if (typeProduct !== 'P') {
          this.form.pack_name.required = false;
          this.form.pack_name.readonly = true;
          this.form.pack = []
          return;
        }
        if (this.form.client.value !== null) {
          await this.getWithOutTreeCategory(this.categoryField, this.form.client.value.id)
        }
        this.form.pack_name.required = true;
        this.form.pack_name.readonly = false;
        this.form.pack = [
          {
            id: utils.defaultFields({value: 0}),
            category: Object.assign({}, this.categoryField),
            // ESTOS SON NECESARIOS
            product: utils.defaultFields({_type: 'select'}),
            stock: utils.defaultFields(),
          }
        ]
        this.form.specific_product.value = this.form.specific_product.options.find(options => options['id'] === '--');
      },
      async getClient(clientField){
        const path = '/api/core/v1.0/client/';
        const filter = {
          status: true,
          deleted: false
        };
        await axios.get(path, {params: filter}).then((response) => {
          if(response.status === 200){
            clientField.options = response.data;
            // clientField.value = clientField.options.find(option => clientField.value === option.id);
          }
        });
      },
      async loadData(objectId){
        let data = {};
        let responseData;
        const defaultFieldValues = {
          specific_product: {
            _type: 'select',
            options: utils.specificProduct
          },
        };
        const path = `/api/inventory/v1.0/product/${objectId}/`;
        await axios.get(path).then(async (response) => {
          responseData = response.data;
          await utils.loadDataStructure(data, responseData, defaultFieldValues);
        }).catch((error) => {
          console.log(error.response);
        });
        // GATILLAMOS EL CAMBIO DEL CLIENTE
        await this.getWithOutTreeCategory(this.categoryField, responseData['client'][['id']]);
        this.form.pack_name = data['pack_name'];
        this.form.image = data['image'];
        this.form.initial_stock = data['initial_stock'];
        this.form.client = await utils.defaultFields({
          _type: 'select',
          value: await this.form.client.options.find(options => options['id'] === data['client'].id.value),
          options: this.form.client.options,
        });
        this.form.type = await utils.defaultFields({
          _type: 'select',
          value: await this.form.type.options.find(options => options['id'] === responseData['type']),
          options: this.form.type.options,
        });
        if (this.form.type.value.id === 'U') {
          this.form.pack_name.required = false;
        }
        this.form.category = utils.defaultFields(
            {
              value: data['category'].id.value,
              _type: 'select'
            }
        );
        this.form.specific_product.value = data['specific_product'].options.find(options => options['id'] === data['specific_product'].value);
        if(!('productwine' in data)){
          this.form.productwine = {
            year: utils.defaultFields({required: false}),
            cc: utils.defaultFields({required: false})
          }
        }
        // GENERO UN CONTADOR
        let cont = 0;
        this.form.pack = [];
        // ASIGNO LA DATA DE LA ESTRUCTURA CARGA
        responseData['pack'].forEach( async (item) => {
          // VOY AGREANDO ELEMENTOS
          const _row = {
            id: utils.defaultFields({value: cont}),
            // PARA CLONAR
            category: Object.assign({}, this.categoryField),
            // ESTOS SON NECESARIOS
            product: utils.defaultFields({_type: 'select'}),
            stock: utils.defaultFields({ value: item['stock'] }),
          };
          // SELECCIONAMOS LA CATEGORÍA
          _row['category'].value = _row['category'].options.find(_item => _item['id'] === item['category']);
          // GATILLO LOS CAMBIOS DE CATEGORIÁS PARA TENER EL PRODUCTO
          await this.setProductByCategory(_row, item['category']);
          // SELECCIONAMOS EL PROCUCTO
          _row['product'].value = _row['product'].options.find(_item => _item['id'] === item['product']);
          // ASIGNAMOS EL CONTADOR
          // CAMBIO EL STOCK INICIAL
          _row['stock'].value = item['stock'];
          // GATILLO EL CAMBIO
          // this.setProductFilter(this.form.pack, _row);
          // LO AGREGO AL FORMUALRIO
          this.form.pack.push(
              _row
          );
          // console.log(row);
          // SUMO EL CONTADOR
          cont++;
        });
        // AGREGO LA FOTO POR DEFECTO
        this.$refs.uploadImage.images.push(data['image'].value);
      },
      async setProductByCategory(productRow, categoryId, defaultValue=null){
        const path = '/api/inventory/v1.0/product/';
        const config = {
          params: {
            category: categoryId,
            status: true,
            deleted: false
          }
        };
        await axios.get(path, config).then((response) => {
          if(response.status === 200){
            // VACÍO LOS OPTIONS
            productRow.product.options = [];
            // TENGO LAS OPCIONES
            let options = response.data;
            // CUANDO SON IGUALES ES PORQ SE ACTUALIZA EL STOCK DEL PRODUCTO O NO HABÍA NINGUNO SELECCIONADO
            // GUARDO TODAS LOS PRODUCTOS SELECCIONADOS DE LA CATEGORÍA
            let selected = [];
            // BUSCO ALGÚN SELECT QUE TENGA LA CATEGORÍA
            for(let i = 0; i < this.form.pack.length; i++){
              // SI SON LA MISMA CATEGORÍA
              if(this.form.pack[i]['category']['value']['id'] === categoryId){
                // VALIDO QUE HAYA ALGO SELECCIONADO
                if(this.form.pack[i]['product']['value']['id']){
                  // CUANDO ES DISTINTO A NULO ES PORQ SOLO QUIERO ACTUALIZAR
                  // VALIDO QUE LA FILA QUE QUIERO ACTUALIZAR NO SE LE QUITE EL VALOR SELECCIONADO
                  if(defaultValue === null || productRow['id']['value'] !== this.form.pack[i]['id']['value']){
                    selected.push(
                        this.form.pack[i]['product']['value']['id']
                    );
                  }
                }
              }
            }
            // PARA RECUPERAR EL VALOR SELECCIONADO APRA CUANDO CAMBIO DE CATEGORÍA
            if(this.lastProductSelected !== ''){
              // BUSCO ALGÚN SELECT QUE TENGA LA CATEGORÍA ANTERIOR
              for(let i = 0; i < this.form.pack.length; i++){
                // VALIDO QUE HAYA UNA ÚLTIMA CATEGORÍA SELECCIONADA
                if(this.lastCategorySelected != null){
                  // SI SON LA MISMA CATEGORÍA
                  if(this.form.pack[i]['category']['value']['id'] === this.lastCategorySelected['id'] && defaultValue === null){
                    // A SUS OPCIONES LE AGREGO EL ELEMENTO SELECCIONADO DE LA CATEGORÍA CAMBIADA
                    this.form.pack[i]['product'].options.push(
                        this.lastProductSelected
                    );
                  }
                }
              }
            }
            // RECORRO TODAS LAS OPCIONES SELECCIONADAS
            selected.forEach((item) => {
              // LA QUITO DE LAS OPCIONES SELECCIONABLES
              const index = options.findIndex(option => option['id'] === item);
              if(index !== -1){
                options.splice(index, 1);
              }
            });
            productRow.product.options = options;
            if(defaultValue !== null){
              productRow.product.value = productRow.product.options.find(item => item['id'] === defaultValue);
            }else{
              productRow.product.value = '';
            }
          }
        });
      },
      setLastRowSelected(lastRow){
        this.lastCategorySelected = lastRow['category']['value'];
        this.lastProductSelected = lastRow['product']['value'];
        this.lastRow = lastRow;
      },
      addProduct(listProducts, id){
        listProducts.push(
            {
              id: utils.defaultFields({value: id}),
              // PARA CLONAR
              category: Object.assign({}, this.categoryField),
              // ESTOS SON NECESARIOS
              product: utils.defaultFields({_type: 'select'}),
              stock: utils.defaultFields(),
            }
        );
        this.productId++;
      },
      async getWithOutTreeCategory(inputCategory, clientId){
        const path = `/api/inventory/v1.0/category_without_tree/`;
        const config = {
          params: {
            client_id: clientId,
          }
        };
        await axios.get(path, config).then(async (response) => {
          inputCategory.options = response.data;
        }).catch((error) => {
          console.log(error);
        });
        this.cleanProducts(this.form.pack, this.productId);
      },
      cleanProducts(productsField, id){
        while(productsField.length !== 0){
          productsField.splice(0, 1);
        }
        this.addProduct(productsField, id);
      },
      setProductFilter(listProductField, selectedValue){
        // SI HABÍA UN ELEMENTO SELECCIONADO PREVIAMENTE
        if(this.lastProductSelected !== ''){
          // BUSCO TODOS LOS PRODUCTOS QUE PERTEZCAN A LA MISMA CATEGORÍA DEL ÚLTI MPRODUCTO SELECCIONADO Y LO AGREGO COMO OPCIÓN EXCEPTUANDO DEL QUE SE DESELCCIONÓ
          listProductField.forEach((item) => {
            if(item['category']['value']['id'] === this.lastRow['category']['value']['id'] && item['id']['value'] !== this.lastRow['id']['value']){
              item['product'].options.push(
                  this.lastProductSelected
              );
            }
          });
        }
        // SE BORRA EL QUE SE SELECCIONÓ AHORA
        listProductField.forEach(function (item) {
          // SI LAS CATEGORÍAS SON IGUALES Y  NO ESTAMOS HABLANDO DEL MISMO SELECT EN EL QUE SE SELECCIONÓ
          if(item['category']['value']['id'] === selectedValue['category']['value']['id'] && item['id']['value'] !== selectedValue['id']['value']){
            const index = item['product'].options.findIndex(item => item['id'] === selectedValue['product']['value']['id']);
            if(index !== -1){
              item['product'].options.splice(index, 1);
            }
          }
        });
      },
      deleteProduct(listProducts, id){
        if(listProducts.length > 1){
          // INDEX DE LA FILA A ELIMINAR
          const index = listProducts.findIndex(item => item['id'].value === id);
          // ELEMENTO A ELIMINAR
          const element = listProducts[index];
          this.form.pack.forEach((item) => {
            // BUSCO TODAS LAS FILAS QUE TIENEN ESA CATEGORÍA
            if(item['category']['value']['id'] === element['category']['value']['id']){
              // SI TIENEN LA MISMA CATEGORÍA, SE AGREGA COMO UNA NUEVA SELECCIÓN Y VALIDO QUE HAYA ALGO SELECCIONADO
              if(element['product']['value']){
                item['product'].options.push(
                    element['product']['value']
                );
              }
            }
          });
          listProducts.splice(index, 1);
        }else{
          this.$swal({
            type: 'error',
            title: 'No puedes eliminar este producto.',
            html: `No se puede eliminar, debido a que debes tener como mínimo 1 producto a despachar.`,
          }).then(() => {
            this.place = null;
            this.$forceUpdate();
          });
        }
      },
    }
  }
</script>